import jquery from 'jquery';
window.jQuery = jquery;
window.$ = jquery;
window.jquery = jquery;

import { Slider, Sticky, Reveal, Accordion } from 'foundation-sites';
import { initForms } from './modules/forms';
import { initNavigation } from './modules/navigation';
// import { initFontAwesome } from './modules/fontAwesome';
import { initFilterForm } from './modules/filterform';
import { initSideCart } from './modules/sideCart';
import { initCart } from './modules/cart';
import { initProductGallerySwiper, initProductSwiper, initVivaBanners, initButtonsSwiper } from './modules/sliders';
import { initExpandableContent } from './modules/expandableContent';
import { initProductVideos } from './modules/productVideos';
import { initLazyLoad } from './modules/lazyLoad';
import { initCheckout } from './modules/checkout';
import { initMasonry } from './modules/masonry';
import{ initGallery } from './modules/gallery'
import{ initColumns } from './modules/columns'
import{ initSmoothScrolling } from './modules/smoothScroll'
import{ initPostCodeCheck } from './modules/postCodeCheck'
import{ initQuickOrderForm } from './modules/quickOrderForm'
import CookieConsent from './modules/cookieconsent';
import { initCaravanRentals } from './modules/caravanRentals';
import { initProductDetail } from './modules/productDetail';
import { initCaravanStorage } from './modules/caravanStorage';

//import { initParallax } from './modules/parallax';
//import MobileDetect from 'mobile-detect';

{
  'use strict';

  // Push consent to DataLayer
  const consent = new CookieConsent();
  consent.pushToDataLayer();

  //const md = new MobileDetect(window.navigator.userAgent);

  // If Foundation modules are installed uncomment this line
  $(document).foundation();

  $(document).ready(() => {
    initForms();
    initFilterForm();
    initNavigation();
    //initFontAwesome();
    initVivaBanners();
    initSideCart();
    initCart();
    initPostCodeCheck();
    initProductGallerySwiper();
    initProductSwiper();
    initButtonsSwiper();
    initExpandableContent();
    initProductVideos();
    initLazyLoad();
    initCheckout();
    initMasonry();
    initGallery();
    initColumns();
    initSmoothScrolling();
    initQuickOrderForm();
    initProductDetail();

    initCaravanRentals();
    initCaravanStorage();

    //initParallax('.banner__image',md);

    // Open the newsletter modal if it exists
    const modal = $('#newsletter-modal');
    if (modal.length) {
      new Foundation.Reveal(modal).open();
    }

    $('.content-block__content table').each(function(e){
      $(this).wrap( "<div class='table-scroll'></div>" );
    });

    $('.btn-close-modal').on('click', function () {
      var div = $(this).closest('div.reveal-modal').first();
      $(div).foundation('reveal', 'close');
    })

  });



}
